import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { useStoreActions } from '~/store/store-context';
export const useScheduledInvoiceDraft = function useScheduledInvoiceDraft(relationshipId, date) {
    let { refreshOnHookMount = false } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _ref;
    const { api } = useStoreActions();
    const { data, isLoading } = useQueryState({
        queryKey: [
            QueryKeys.InvoiceDraftByDate,
            relationshipId,
            (_ref = date === null || date === void 0 ? void 0 : date.toISOString()) !== null && _ref !== void 0 ? _ref : null
        ],
        queryFn: async ()=>{
            var _ref;
            return (_ref = await api.invoiceDraft.getByDate(relationshipId, date)) !== null && _ref !== void 0 ? _ref : null;
        },
        enabled: !!relationshipId && date != null,
        refreshOnHookMount
    });
    return {
        draft: data !== null && data !== void 0 ? data : null,
        isLoading
    };
};
